import { memoize } from 'lodash';
import { pathToRegexp } from 'path-to-regexp';

// Memoizing `pathToRegexp` because the parsing of the pattern and converstion
// to a regular expression is a somewhat wasteful operation. 10000 conversions
// takes about 130 milliseconds.
const memoizedPathToRegexp = memoize(pathToRegexp);

// From the provided array of `routes`, returns the route object matching the
// provided `path`. Route objects are considered to match if their `pattern`
// property, when converted to a `path-to-regexp` regular expression, matches
// the provided `path`.
const findMatchingRoute = (routes, path) => {
  for (const route of routes) {
    if (memoizedPathToRegexp(route.pattern).test(path)) {
      return route;
    }
  }

  return null;
};

export default findMatchingRoute;
